import { activeVisibility, int, intText, oneOf, text, yesNo } from '@/hooks/useUrlState';

export type TerminalsSortColumn = 'name' | 'poiid' | 'battery' | 'connected' | 'active' | 'updatedAt';

/** DataGrid column `id` → API `sortField` (see TerminalRepository::searchPaginated); its keys are the values `sort` accepts. */
export const TERMINAL_COLUMN_SORT: Record<TerminalsSortColumn, string> = {
  name: 'name',
  poiid: 'poiid',
  battery: 'batteryLevel',
  connected: 'connected',
  active: 'active',
  updatedAt: 'updatedAt',
};

export const TERMINALS_DEFAULT_SORT: { sort: TerminalsSortColumn; dir: 'asc' | 'desc' } = { sort: 'name', dir: 'asc' };

/** The /terminals query string, in this order (see README "List pages, URL state"). */
export const terminalsUrlSchema = {
  search: text(),
  connected: yesNo(),
  batteryMin: intText({ min: 0, max: 100 }),
  batteryMax: intText({ min: 0, max: 100 }),
  show: activeVisibility('active'),
  sort: oneOf(TERMINAL_COLUMN_SORT, TERMINALS_DEFAULT_SORT.sort),
  dir: oneOf<'asc' | 'desc', 'asc' | 'desc'>({ asc: true, desc: true }, TERMINALS_DEFAULT_SORT.dir),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};

/** The keys that live in the collapsible Filters panel: the panel opens on mount when any is set. */
export const TERMINALS_ADVANCED_KEYS = [
  'show',
  'connected',
  'batteryMin',
  'batteryMax',
] as const satisfies readonly (keyof typeof terminalsUrlSchema)[];
